<template>
  <div class="h-auto bg-gray-200">
    <div
      class="flex flex-wrap w-full justify-center md:justify-between items-center py-3 bg-white shadow-lg"
    >
      <div class="flex ml-0 md:ml-6 cursor-pointer pr-4 items-center" @click="goBack">
        <img alt="school logo" class="h-10 w-10" src="../../images/gciosa.png" />
        <span
          class="ml-1 text-xl text-white text-blue-900 font-semibold invisible md:visible"
        >GCIOSA</span>
      </div>

      <ul
        class="md:flex sm:block mt-6 md:mt-0 ml-6 md:ml-0 overflow-x-auto mr-0 md:mr-10 font-semibold pt-0 md:pt-2"
      >
        <li
          class="mb-2 px-4 py-1 bg-white border-red-900 hover:bg-red-900 rounded-lg text-red-900 hover:text-white"
          style="border-width: 1px"
        >
          <a @click="logout" class="text-sm">Logout</a>
        </li>
      </ul>
    </div>

    <div class="px-4 md:px-12 pt-6">
      <span
        class="block w-full pt-1 text-xl font-semibold mb-4 tracking-wider border-orange-500"
        style="border-bottom-width: 1px"
      >Announcements</span>

      <!-- loader -->
      <div v-if="loading" class="h-screen w-full">
        <div class="flex h-screen items-center">
          <vue-loaders
            name="ball-spin-fade-loader"
            color="#2a4365"
            class="flex m-auto my-4"
            scale="1"
          ></vue-loaders>
        </div>
      </div>

      <!-- add announcement button and announcement list -->
      <div v-else>
        <button
          class="flex flex-row items-center px-3 py-2 text-white text-sm font-semibold bg-green-600 hover:bg-green-900 rounded mb-4"
          @click="addAnnouncement"
        >
          <plus-icon class="mr-1" />Add announcement
        </button>

        <div
          v-for="item in announcements"
          :key="item.id"
          class="p-4 mb-3 w-full items-center bg-white shadow-md rounded-md"
        >
          <!--            <div  class="flex">-->

          <!--                <div class="flex items-center">-->
          <!--            <images class="w-10 h-10 rounded-full" src="https://res.cloudinary.com/ederchrono/image/upload/v1556684546/wotw-013/nature-1.jpg" alt="user.name">-->
          <!--                    <SpeakerIcon />-->

          <!--                </div>-->

          <div class="container">
            <h1 class="flex-wrap text-base">
              <a
                class="underline text-black cursor-pointer"
                @click="gotoDetails(item.id)"
              >{{item.title}}</a>
            </h1>

            <p
              class="flex-wrap pr-4 text-gray-500 text-base font-light w-11/12 font-sans tracking-wide leading-loose truncate"
            >{{item.contents}}</p>
          </div>

          <div class="flex items-center justify-between leading-none mt-2">
            <p class="pr-4 text-gray-500 font-light font-sans">Announcer: {{item.announcer}}</p>
            <p
              class="flex items-center pr-4 text-gray-500 font-light font-sans"
            >{{item.created_at | formatDateSlash }}</p>
          </div>

          <div class="flex flex-row justify-end mt-4">
            <EditIcon style="color: blue" @click="editAnnouncement(item.id)" />
            <Trash2Icon class="text-red-600 ml-4" @click="deleteAnnouncement(item.id)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>

<script>
import Axios from "axios";
// import router from "../../routes";
import { EditIcon, Trash2Icon, PlusIcon } from "vue-feather-icons";
export default {
  name: "announcement",
  components: {
    EditIcon,
    Trash2Icon,
    PlusIcon
  },
  data: function() {
    return {
      loading: false,
      announcements: []
    };
  },
  // data
  methods: {
    getAnnouncements: function() {
      this.loading = true;
      let token = localStorage.getItem("token");
      if (token === null) {
        this.$router.push("/");
        this.$swal("Pls login");
      } else {
        Axios.get("/api/announcements", {
          headers: { Authorization: `Bearer ${token}` }
        }).then(response => {
          // console.log(response.data);
          this.loading = false;
          if (response.data.status) {
            this.announcements = response.data.data;
          } else {
            this.$router.push("/");
            this.$swal("Pls login");
          }
        });
      }
    },
    addAnnouncement() {
      this.$router.push("/admin/add_edit_announcement");
    },
    editAnnouncement(id) {
      this.$router.push(`/admin/add_edit_announcement/${id}`);
    },
    deleteAnnouncement(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          let token = localStorage.getItem("token");
          return Axios.delete(`/api/announcements/${id}`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          }).then(response => {
            // this.$swal.stopLoading();
            if (response.data.status === true) {
              this.announcements = response.data.data;
              this.$swal("Deleted!", "Your file has been deleted.", "success");
            } else {
              this.$swal("Please login");
              this.$router.push("/");
            }
          });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      });
      // .then(result => {
      //   // this.$swal.showLoading();
      //   if (result.value) {
      //     console.log(result.value);
      // let token = localStorage.getItem("token");
      // Axios.delete(`/api/announcements/${id}`, {
      //   headers: {
      //     "Content-Type": "application/json",
      //     Authorization: `Bearer ${token}`
      //   }
      // }).then(response => {
      //   // this.$swal.stopLoading();
      //   if (response.data.status === true) {
      //     this.announcements = response.data.data;
      //     this.$swal("Deleted!", "Your file has been deleted.", "success");
      //   } else {
      //     this.$swal("Please login");
      //     this.$router.push("login");
      //   }
      // });
      //   }
      // });
    },
    gotoDetails: function(id) {
      console.log(id);
      this.$router.push(`/announce_details/${id}`);
    },
    logout: function() {
      localStorage.clear();
      this.$router.push("/");
    },
    goBack() {
      this.$router.back();
    }
  },

  created() {
    this.getAnnouncements();
  }
};
</script>

